<section data-pw="logout" class="logout">
  <div @fadeIn class="nes-flex-col nes-mt-4">
    <mnz-button
      data-pw="logout__button"
      [class.button--fullWidth]="isHandsetPortrait$ | async"
      [loading]="loading$ | async"
      (pressed)="logout()"
      >{{ 'LOGOUT_PAGE.BUTTON' | translate }}</mnz-button
    >
  </div>
</section>
